import React from 'react';
import $ from "jquery";
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Button, Table } from 'semantic-ui-react';

import Title from '../../title';
import Loading from '../../loading';
import getFormatedDate from '../../../functions/date';
import Permission from '../../../functions/permission';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import MakeDecimalPoints from '../../makedecimalpoints';
import ExpenseHeadReport from './ExpenseHeadReport';

export default class ExpenseReport extends React.Component {

    state = {
        fromDate: getFormatedDate(new Date(), 'fromDate'),
        toDate: getFormatedDate(new Date(), 'toDate'),
        report: [], menuPermission: {}
    }

    componentDidMount() {
        this.menuPermission();
        
    }

    menuPermission() {
        let menuPermission = Permission('hsncode-report', this.props.menus);
        if (menuPermission.view) {
            this.ExpenseReport();
            this.setState({ menuPermission })
        }
    }

    ExpenseReport = () => {
        let context = this;
        let { fromDate, toDate } = this.state;
        this.setState({ load: true, message: 'FETCHING REPORT!!!!' });
        let data = (ReadCookie("branch"));
        let branch;
        for (var i = 0; i < data.length; i++) {
            branch = data[i].branch_id;
        }
        $.ajax({
            type: 'POST',
            data: { fromDate, toDate, branch },
            url: Server() + 'Accountings/ExpenseReport/GetReport.php',
            success: function(data) {
                try {
                    data = JSON.parse(data);
                    context.setState({ report: data, load: false })
                } catch (error) {
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                context.setState({ load: false });
            }
        });
    }

    render() {
        let { openDrawer } = this.props;
        let { load, message, menuPermission, report } = this.state;
        let i = 1;
        return (
            <div>
                <Title title={'Income And Expense Report'} openDrawer={openDrawer} />
                <Loading load={load} message={message} />
                { !menuPermission.view ?
                    <center style={{color: 'red'}}>You Are Not Allow To Access This Menu!!!</center>
                    :
                    <div style={{margin: '0.5%'}}>
                        <div style={{display: 'flex'}}>
                            <TextField label="From" type="date"
                            onChange={(e) => this.setState({fromDate: e.target.value})}
                            defaultValue={this.state.fromDate} />

                            <TextField style={{marginLeft: 20}} label="To" type="date"
                            onChange={(e) => this.setState({toDate: e.target.value})}
                            defaultValue={this.state.toDate} />
                            <Button primary onClick={this.ExpenseReport} style={{marginLeft: '1%'}}>Submit</Button>
                        </div>
                        <Table celled singleLine id='export'>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell id='tableheader'><center>Sino</center></Table.HeaderCell>
                                    <Table.HeaderCell id='tableheader'><center>HSN Code</center></Table.HeaderCell>
                                    <Table.HeaderCell id='tableheader'><center>Expense</center></Table.HeaderCell>
                                    <Table.HeaderCell id='tableheader'><center>Opening Balance</center></Table.HeaderCell>
                                    <Table.HeaderCell id='tableheader'><center>Colsing Balance</center></Table.HeaderCell>
                                    <Table.HeaderCell id='tableheader'><center>Action</center></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                { 
                                    report.map((c) => {
                                        return (
                                            <Table.Row>
                                                <Table.Cell><center>{i++}</center></Table.Cell>
                                                <Table.Cell>{c.hsncode}</Table.Cell>
                                                <Table.Cell>{c.name}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(c.openingBalance))}</Table.Cell>
                                                <Table.Cell style={{textAlign: 'right'}}>{MakeDecimalPoints(Number(c.closingBalance))}</Table.Cell>
                                                <Table.Cell><ExpenseHeadReport item={c} fromDate={this.state.fromDate} toDate={this.state.toDate} /></Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                }
                                <Table.Row>
                                    
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div>
                }
            </div>
        )
    }
}